/**
 * Lightweight currency selector used by reimbursement & travel forms.
 *
 * The supported list matches `backend/forex.py::SUPPORTED_CURRENCIES`. Adding/removing
 * an entry should be done in both places.
 */
import React from "react";

export const SUPPORTED_CURRENCIES = [
  { code: "USD", label: "USD · US Dollar", symbol: "$" },
  { code: "BRL", label: "BRL · Real", symbol: "R$" },
  { code: "EUR", label: "EUR · Euro", symbol: "€" },
  { code: "GBP", label: "GBP · British Pound", symbol: "£" },
  { code: "CAD", label: "CAD · Canadian Dollar", symbol: "CA$" },
  { code: "MXN", label: "MXN · Mexican Peso", symbol: "MX$" },
  { code: "ARS", label: "ARS · Argentine Peso", symbol: "AR$" },
  { code: "JPY", label: "JPY · Japanese Yen", symbol: "¥" },
  { code: "CHF", label: "CHF · Swiss Franc", symbol: "CHF" },
];

export function currencySymbol(code) {
  return SUPPORTED_CURRENCIES.find((c) => c.code === (code || "USD").toUpperCase())?.symbol || code;
}

export default function CurrencySelect({ value, onChange, testid, className = "" }) {
  return (
    <select
      data-testid={testid}
      value={value || "USD"}
      onChange={(e) => onChange(e.target.value)}
      className={`sw-input !py-1 !text-[12px] ${className}`}
    >
      {SUPPORTED_CURRENCIES.map((c) => (
        <option key={c.code} value={c.code}>{c.label}</option>
      ))}
    </select>
  );
}
